import React from "react";
import { CheckOutlined } from "@ant-design/icons";
import styles from "./style.module.scss";

/**
 * Compressed wizard stepper for the pivot step only.
 */
export default function WelcomePivotCompressedStepper({
  activeStepNumber,
  activeLabel,
  completedLabel,
  remainingLabel,
}) {
  return (
    <div className={styles.compressedStepper}>
      <div className={styles.completedPill}>
        <span className={styles.completedIcon} aria-hidden="true">
          <CheckOutlined />
          <CheckOutlined />
        </span>
        <span>{completedLabel}</span>
      </div>
      <div className={styles.stepperDivider} />
      <div className={styles.activePill}>
        <span className={styles.activeStepNum}>{activeStepNumber}</span>
        <span className={styles.activeStepLabel}>{activeLabel}</span>
      </div>
      <div className={styles.stepperDivider} />
      <span className={styles.remainingLabel}>{remainingLabel}</span>
    </div>
  );
}
